export default __webpack_public_path__ + "static/media/Tome of the Undying.6602107b.jpg";